import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// @ts-ignore
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Actions
import { removeMyTimesheetEntry } from 'services/myTimesheetEntries/actions';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';

// @ts-ignore
import SubmittingButton from 'components/SubmittingButton';

interface StateProps {
    isOpen?: boolean;
    id?: string;
}

interface DispatchProps {
    updateQueryString: Function;
    removeMyTimesheetEntry: Function;
}

type ComponentProps = StateProps & DispatchProps;

export class MyTimesheetEntriesDeleteModal extends React.PureComponent<
    ComponentProps
> {
    handleClose = (): void => {
        this.props.updateQueryString({
            myTimesheetEntriesDeleteModal: undefined,
            selectedEntry: undefined
        });
    };

    handleSubmit = (): void => {
        this.props.removeMyTimesheetEntry(this.props.id);

        this.handleClose();
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) return null;

        return (
            <Modal
                size="tiny"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="TimesheetDeleteModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Delete entry</Modal.Header>
                    <Modal.Content>
                        <ErrorAlert namespace="TIMESHEET_DELETE" />
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <SubmittingButton
                                    type="submit"
                                    namespace="TIMESHEET_DELETE"
                                    negative
                                    fluid
                                    onClick={this.handleSubmit}
                                >
                                    Confirm
                                </SubmittingButton>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isOpen: makeSelectQueryStringBooleanValue('myTimesheetEntriesDeleteModal'),
    id: makeSelectQueryStringValue('selectedEntry')
});

export default connect<StateProps, DispatchProps>(
    mapStateToProps,
    {
        updateQueryString,
        removeMyTimesheetEntry
    }
)(MyTimesheetEntriesDeleteModal);
